import React, { memo } from 'react';
import { Box, Icon, InputBase, Paper } from '@mui/material';


interface IInputDeBuscaProps {
  pesquisa: string
  setPesquisa: (value: React.SetStateAction<string>) => void
  placeholder: string
}
export const InputDeBusca: React.FC<IInputDeBuscaProps> = memo(({ pesquisa, setPesquisa, placeholder }) => {

  return (
    <Box paddingLeft={2} gap={1} display='flex' alignItems='center' component={Paper} width='30%'>
      <Icon sx={{ opacity: 0.5 }}>search</Icon>
      <InputBase
        fullWidth
        placeholder={placeholder}
        title={placeholder}
        sx={{ p: 0.75 }}
        value={pesquisa}
        onChange={(event) => setPesquisa(event.target.value)}
      />
    </Box>
  );
});
